import { render, staticRenderFns } from "./ScoreList.vue?vue&type=template&id=09998080&scoped=true&"
import script from "./ScoreList.vue?vue&type=script&lang=js&"
export * from "./ScoreList.vue?vue&type=script&lang=js&"
import style0 from "./ScoreList.vue?vue&type=style&index=0&id=09998080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09998080",
  null
  
)

export default component.exports